export const products = {
  alerts: {
    successCreated: 'Je product is verstuurd ter goedkeuring.',
    successDeleted: 'Je product is verwijderd.',
    successUpdated: 'Je product is bewerkt.',
  },
  breadcrumb: {
    create: 'Product aanmaken',
    edit: 'Product bewerken',
    overview: 'Producten',
  },
  createEdit: {
    blocker: {
      create: 'Ben je zeker dat je de pagina wilt verlaten? Je product is niet opgeslagen.',
      edit: 'Ben je zeker dat je de pagina wilt verlaten? De wijzigingen aan je product zijn niet opgeslagen.',
    },
    details: {
      title: 'Productdetails',
    },
    info: {
      description: 'Vul hier de informatie van je product in',
      title: 'Productinformatie',
    },
    submit: {
      create: 'Product aanmaken',
      edit: 'Product bewerken',
      save: 'Opslaan',
    },
    title: {
      create: 'Nieuw product',
      edit: 'Bewerk product',
    },
  },
  fields: {
    activityType: {
      label: 'Soort prestatie',
      placeholder: 'Soort prestatie',
      tooltip:
        'Kies welk soort prestatie van toepassing is. <a href="https://knowledge.creativeshelter.be/wanneer-factureer-je-welke-soort-prestatie" target="_blank">Twijfel je? Check hier wanneer je welke prestatie factureert.</a>',
    },
    categories: {
      label: 'Categorieën',
      placeholder: 'Voeg een categorie toe, zoals: montage, postproductie, vertaling, eindredactie …',
    },
    name: {
      inLanguage: {
        en: 'Productnaam Engels',
        fr: 'Productnaam Frans',
        nl: 'Productnaam Nederlands',
      },
      label: 'Productnaam',
      placeholder: 'Productnaam',
    },
    price: {
      label: 'Prijs (excl. btw)',
      tooltip:
        'Gebruik je vaak dezelfde prijs voor je product? Vul deze al in en bespaar jezelf wat werk. Je kan dit nog wijzigen bij het opstellen van je factuur.',
    },
    unit: {
      label: 'Eenheid',
      placeholder: 'Kies een eenheid',
      tooltip:
        'Gebruik je vaak dezelfde eenheid voor je product? Vul deze al in en bespaar jezelf werk. Je kan dit nog wijzigen bij het opstellen van je factuur.',
    },
  },
  header: {
    actionBlock: {
      button: 'Product aanmaken',
    },
    title: 'Producten',
  },
  modal: {
    add_one: '{{count}} product toevoegen',
    add_other: '{{count}} producten toevoegen',
    add_zero: 'Product(en) toevoegen',
    createNew: 'Nieuw product aanmaken',
    title: 'Product(en) toevoegen',
  },
  overview: {
    columns: {
      creativeWork: 'Type',
      name: 'Productnaam',
      price: 'Prijs',
      productCategories: 'Categorieën',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          InReview: 'Ter goedkeuring',
          Rejected: 'Afgewezen',
        },
        title: 'Status',
      },
    },
    deleteModal: {
      description: 'Ben je zeker dat je dit product wilt verwijderen?',
      title: 'Product verwijderen',
    },
    infoCard: {
      instantInvoices: {
        description:
          'Een factuur met alleen goedgekeurde producten? Die kan meteen naar je klant, zonder dat wij deze nog eens extra checken.',
        href: 'https://knowledge.creativeshelter.be/wat-is-instant-factureren',
        label: 'Meer info',
        title: 'Instant factureren',
      },
      products: {
        description: 'Een factuurlijn die je eenmalig aanmaakt en erna telkens opnieuw kan gebruiken op een factuur of offerte.',
        href: 'https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze',
        label: 'Meer info',
        title: 'Producten',
      },
      title: 'Informatie over producten',
    },
  },
};
